import { render, staticRenderFns } from "./offlinePromotionList.vue?vue&type=template&id=3beda974&scoped=true&"
import script from "./offlinePromotionList.vue?vue&type=script&lang=js&"
export * from "./offlinePromotionList.vue?vue&type=script&lang=js&"
import style0 from "./offlinePromotionList.vue?vue&type=style&index=0&id=3beda974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beda974",
  null
  
)

export default component.exports